import React, { useMemo, useState } from 'react';
import { Layout, Segment, Table, Bubble } from 'tea-component';
import { getLocale, useIntl } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';
import SvgIcon from '@home/components/SvgIcon';
import { getStatsDetailParams } from '@op/utils/storageUtils';
import { getEventName, getEventTypeTagClassName } from '../utils';
import { openWindowUrl } from '@op/utils/url';
import { formatTimeToShow } from '@op/utils/time';
import { transRegionText } from '@op/utils';
import './index.scss';
import { NO_DATE } from '@op/constants';
const { Body, Content } = Layout;

const { scrollable } = Table.addons;
export default function EventDetails() {
  const { formatMessage } = useIntl();
  const lang = getLocale();

  const [value, setValue] = useState('all');

  const { time, tabs } = useMemo(() => {
    const data = getStatsDetailParams();
    const { time, list } = data || {};
    const allRecord: Array<any> = [];
    const tabs = list.map(
      (item: { name: any; value: any; name_cn: any; elements: Array<any> }) => {
        const records = item.elements || [];
        allRecord.push(...records);
        return {
          name: item.name,
          value: item.name,
          name_cn: item.name_cn,
          tableRecord: records,
        };
      },
    );

    tabs.unshift({
      name: 'All',
      value: 'all',
      name_cn: '全部',
      tableRecord: allRecord,
    });
    console.log('tabs :: ', tabs, time);
    return { time, tabs };
  }, []);

  const tableRecord = useMemo(() => {
    const item = tabs.find((tab: { value: string }) => tab.value === value);

    return item?.tableRecord || [];
  }, [value, tabs]);

  const tableColumns = useMemo(() => {
    const tableColumnsList: Array<any> = [
      {
        key: 'date',
        header: formatMessage({ id: 'Date' }),
        align: 'left',
        width: 240,
        render: (cvm: any) => {
          return formatTimeToShow({
            ...cvm,
            date_type: 'daily',
            link_text: ` ~ `,
          });
        },
      },
      {
        key: 'title',
        header: formatMessage({ id: 'Title' }),
        render: (cvm: any) => {
          return (
            <Bubble
              closeOnScroll
              dark
              content={
                <div className="dbo-scroll-bubble-scroll">
                  {formatMessage({
                    id: getEventName(cvm, lang),
                  })}
                </div>
              }
              overlayClassName="dbo-scroll-bubble"
            >
              <div className="dbo-event-details-table-description">
                {getEventName(cvm, lang)}
              </div>
            </Bubble>
          );
        },
      },
      {
        key: 'Country',
        header: formatMessage({ id: 'Country' }),
        width: 170,
        render: (cvm: any) => {
          return transRegionText(cvm.country, 'Global');
        },
      },
      {
        key: 'Description',
        header: formatMessage({ id: 'Description' }),
        render: (cvm: any) => {
          return (
            <Bubble
              closeOnScroll
              dark
              content={
                <div className="dbo-scroll-bubble-scroll">
                  {formatMessage({
                    id: getEventName(
                      {
                        name: cvm?.description || NO_DATE.EMPTY,
                        name_cn: cvm?.description_cn || NO_DATE.EMPTY,
                      },
                      lang,
                    ),
                  })}
                </div>
              }
              overlayClassName="dbo-scroll-bubble"
            >
              <div className="dbo-event-details-table-description">
                {getEventName(
                  {
                    name: cvm.description,
                    name_cn: cvm.description_cn,
                  },
                  lang,
                )}
              </div>
            </Bubble>
          );
        },
      },
      {
        key: 'source',
        header: formatMessage({ id: 'Source' }),
        width: 140,
      },
      {
        key: 'link',
        header: formatMessage({ id: 'Link' }),
        width: 160,
        render: (cvm: any) => {
          if (!cvm.url) {
            return '-';
          }
          return (
            <div
              className="dbo-view-links"
              onClick={() => openWindowUrl(cvm.url)}
            >
              <span>{formatMessage({ id: 'View Link' })}</span>
              <SvgIcon type="aigc-jump" />
            </div>
          );
        },
      },
    ];

    if (value === 'all') {
      tableColumnsList.unshift({
        key: 'type',
        header: formatMessage({ id: 'Event type' }),
        align: 'left',
        render: (cvm: any) => {
          return (
            <div
              className={`dbo-event-type-tag ${getEventTypeTagClassName(
                cvm.event_type,
              )}`}
            >
              {getEventName(
                {
                  name: cvm.event_type,
                  name_cn: cvm.event_type_cn,
                },
                lang,
              )}
            </div>
          );
        },
        width: 180,
      });
    }

    return tableColumnsList;
  }, [value, formatMessage]);

  return (
    <Layout className="dbo-event-details">
      <Body>
        <Content>
          <Content.Header
            showBackButton
            onBackButtonClick={() => history.go(-1)}
            title={formatMessage({ id: 'Event Details' })}
            subtitle={<div className="dbo-header-subtitle ">{time}</div>}
          />
          <Content.Body full>
            <Segment
              className="segment-light dbo-segment-f12"
              value={value}
              onChange={(value) => setValue(value)}
              options={tabs.map(
                (item: { value: string; name: string; name_cn: string }) => ({
                  text: getEventName(item, lang),
                  value: item.value,
                }),
              )}
            />
            <CardCommon
              className="dbo-event-details-table"
              empty={tableRecord.length === 0}
              emptyHeight={650}
            >
              <Table
                records={tableRecord}
                columns={tableColumns}
                addons={[
                  scrollable({
                    minWidth: 1142,
                  }),
                ]}
                total={tableRecord.length}
              />
            </CardCommon>
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
}
